export default "__VITE_PUBLIC_ASSET__13863fd6__"